var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "mb-5 pa-0 callDetail",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": _vm.callBG(_vm.callDetail.status).header
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.callRef')) + ":\n          " + _vm._s(_vm.callDetail.call_remote_id) + "\n        ")]), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("apps")])], 1), _c('v-list', [_vm.callDetail.status == 'Available' ? _c('v-list-tile', {
    on: {
      "click": function click($event) {
        return _vm.acceptCall(_vm.callDetail.id);
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.acceptCall')))])], 1) : _vm._e(), _vm.callDetail.status == 'Accepted' && !_vm.userHasActiveCall ? _c('v-list-tile', {
    on: {
      "click": function click($event) {
        return _vm.travelCall(_vm.callDetail.id);
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.startTravel')))])], 1) : _vm._e(), _vm.callDetail.status == 'Travelling' ? _c('v-list-tile', {
    on: {
      "click": function click($event) {
        return _vm.checkProximity(_vm.callDetail.id);
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.markArrival')))])], 1) : _vm._e(), _vm.callDetail.status == 'Arrived' ? _c('v-list-tile', {
    on: {
      "click": function click($event) {
        return _vm.arrivalProcessBegin();
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.arrivalComplete')))])], 1) : _vm._e(), _vm.callDetail.status == 'Arrival Completed' || _vm.callDetail.status == 'Departed' ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'callComplete',
        params: {
          id: _vm.callDetail.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.completeCall')))])], 1) : _vm._e(), _vm.callDetail.status == 'Arrival Completed' || _vm.callDetail.status == 'Departed' ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'media',
        params: {
          id: _vm.callDetail.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.media')))])], 1) : _vm._e(), _vm.callDetail.status == 'Arrival Completed' || _vm.callDetail.status == 'Departed' ? _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'scans',
        params: {
          id: _vm.callDetail.id
        }
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.scans')))])], 1) : _vm._e(), _vm.callDetail.status != 'Available' ? _c('v-list-tile', {
    attrs: {
      "id": "resetCallButton"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.resetCall')))])], 1) : _vm._e()], 1)], 1)], 1), _c('v-expansion-panel', {
    attrs: {
      "popout": "",
      "expand": ""
    },
    model: {
      value: _vm.panel,
      callback: function callback($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.callInfo')) + "\n            "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": _vm.callBG(_vm.callDetail.status).header,
      "id": "statusChip"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.callDetail.status) + "\n            ")])], 1), _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.callProblem')) + ":")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.callDetail.description) + "\n            ")]), _vm.callDetail.office_comment ? _c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.scheduledNote')) + ":")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.callDetail.office_comment) + "\n            ")]) : _vm._e(), _c('v-card-text', [_vm.callDetail.scheduled_at ? [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.scheduledAt')) + ":\n                ")]), _vm._v("\n                " + _vm._s(_vm.formatDatetimeWithoutTimeZone(_vm.callDetail.scheduled_at)) + "\n                "), _c('br')] : _vm._e(), [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.estimatedDuration')) + ":")]), _vm._v("\n                " + _vm._s(_vm.estimatedDuration)), _c('br')]], 2), _vm.callDetail.contract_note ? _c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.contractNote')) + ":\n              ")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.callDetail.contract_note) + "\n            ")]) : _vm._e(), _c('v-card-text', [_vm.callDetail.remote_id ? [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.orderNumber')) + ":\n                ")]), _vm._v("\n                " + _vm._s(_vm.callDetail.order_number) + "\n                "), _c('br')] : _vm._e(), _vm.callDetail.call_type ? [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.callType')) + ": ")]), _vm._v("\n                " + _vm._s(_vm.callDetail.call_type) + "\n                "), _c('br')] : _vm._e(), _vm.callDetail.remote_id ? [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.eventId')) + ": ")]), _vm._v("\n                " + _vm._s(_vm.callDetail.remote_id) + "\n                "), _c('br')] : _vm._e()], 2), _c('v-card-text', [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.location')) + ":")]), _vm.callDetail.company ? [_c('br'), _c('span', [_vm._v(_vm._s(_vm.callDetail.company))])] : _vm._e(), _vm.callDetail.address_line_1 ? [_c('br'), _c('span', [_vm._v(_vm._s(_vm.callDetail.address_line_1))])] : _vm._e(), _vm.callDetail.address_line_2 ? [_c('br'), _c('span', [_vm._v(_vm._s(_vm.callDetail.address_line_2))])] : _vm._e(), _vm.callDetail.address_line_3 ? [_c('br'), _c('span', [_vm._v(_vm._s(_vm.callDetail.address_line_3))])] : _vm._e(), _vm.callDetail.city ? [_c('br'), _vm.callDetail.city ? _c('span', [_vm._v(_vm._s(_vm.callDetail.city))]) : _vm._e()] : _vm._e(), _vm.callDetail.county ? [_c('br'), _vm.callDetail.county ? _c('span', [_vm._v(_vm._s(_vm.callDetail.county))]) : _vm._e()] : _vm._e(), _vm.callDetail.postcode ? [_c('br'), _c('span', [_vm._v(_vm._s(_vm.callDetail.postcode))])] : _vm._e(), _vm.callDetail.company_alias ? [_c('br'), _c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.companyAlias')) + ":\n                ")]), _c('span', [_vm._v(_vm._s(_vm.callDetail.company_alias))])] : _vm._e(), _vm.callDetail.telephone ? [_c('br'), _c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.telephone')) + ":\n                ")]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.callDetail.telephone
    }
  }, [_vm._v(_vm._s(_vm.callDetail.telephone))]), _c('br')] : _vm._e()], 2)], 1)], 1), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.callTimes')) + "\n          ")]), _c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.timestamps, function (t) {
    return _c('v-list-tile', {
      key: t.label
    }, [_c('v-list-tile-content', [_c('strong', [_vm._v(_vm._s(t.label))])]), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(_vm.formatDatetimeWithoutTimeZone(t.value)))])], 1);
  }), 1)], 1)], 1)], 1)], 1), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.callHistory')) + "\n          ")]), _vm.callDetail.history ? _c('v-card', _vm._l(_vm.callDetail.history.data, function (item, index) {
    return _c('div', {
      key: item.id
    }, [item.to == 'Available' && index > 1 ? _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.formatDatetimeWithoutTimeZone(item.created_at)) + "\n                " + _vm._s(_vm.$vuetify.t('$vuetify.calls.reset')) + "\n              ")]) : _vm._e(), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.formatDatetimeWithoutTimeZone(item.created_at)) + "\n                " + _vm._s(item.to) + "\n              ")])], 1);
  }), 0) : _vm._e()], 1)], 1)], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm.callDetail.status == 'Available' ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "loading": _vm.acceptPending,
      "color": "green",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "acceptButton"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.acceptCall(_vm.callDetail.id);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.accept')) + "\n      ")]) : _vm._e(), _vm.callDetail.status == 'Accepted' && !_vm.userHasActiveCall ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "loading": _vm.travelPending,
      "color": "orange",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "travelButton"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.travelCall(_vm.callDetail.id);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.travel')) + "\n      ")]) : _vm._e(), _vm.callDetail.status == 'Travelling' ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "loading": _vm.arrivedPending,
      "disabled": _vm.arrivedPending,
      "color": "blue",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "arrivedButton"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.checkProximity();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.arrived')) + "\n      ")]) : _vm._e(), _vm.callDetail.status == 'Arrival Completed' ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "to": {
        name: 'callComplete',
        params: {
          id: _vm.callDetail.id
        }
      },
      "color": "green darken-2",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "completeButton"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.complete')) + "\n      ")]) : _vm._e(), _vm.callDetail.status == 'Arrived' ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "color": "blue darken-2",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "arrivalCompleteButton"
    },
    on: {
      "click": function click($event) {
        return _vm.arrivalProcessBegin();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.arrivalComplete')) + "\n      ")]) : _vm._e(), _vm.callDetail.status == 'Departed' ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "to": {
        name: 'callComplete',
        params: {
          id: _vm.callDetail.id
        }
      },
      "color": "green darken-2",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "endTravelButton"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.complete')) + "\n      ")]) : _vm._e(), _vm.callDetail.status == 'Accepted' && _vm.userHasActiveCall ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "loading": _vm.resetPending,
      "color": "black darken-2",
      "large": "",
      "fixed": "",
      "bottom": "",
      "block": "",
      "dark": "",
      "id": "resetButton"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.reset')) + "\n      ")]) : _vm._e()], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallHeader')) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallBody')) + "\n      ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.confirmReset
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallConfirm')) + "\n        ")])], 1)], 1)], 1), _c('proximity-dialog', {
    ref: "proximityDialog",
    attrs: {
      "distance-to-site": this.distanceToSite
    },
    on: {
      "accept-proximity-warning": _vm.confirmProximity
    }
  }), _c('contract-notes', {
    attrs: {
      "show": _vm.contractNotesDialog,
      "notes": _vm.callDetail.contract_note
    },
    on: {
      "confirmed": function confirmed($event) {
        return _vm.contractNotesConfirmed(_vm.callDetail.id);
      },
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        _vm.contractNotesDialog = false;
      }
    }
  }), _c('sign-in-method', {
    attrs: {
      "show": _vm.signInMethodDialog,
      "notes": _vm.callDetail.sign_in_method,
      "method": _vm.callDetail.sign_in_method,
      "link": _vm.callDetail.sign_in_link
    },
    on: {
      "confirmed": function confirmed($event) {
        return _vm.signInMethodConfirmed(_vm.callDetail.id);
      },
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        ;
        _vm.contractNotesDialog = true, _vm.signInMethodDialog = false;
      }
    }
  }), _c('work-assessment', {
    attrs: {
      "show": _vm.workAssessmentDialog
    },
    on: {
      "confirmed": function confirmed($event) {
        var _vm2;
        return (_vm2 = _vm).workAssessmentConfirmed.apply(_vm2, [_vm.callDetail.id].concat(Array.prototype.slice.call(arguments)));
      },
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        ;
        _vm.signInMethodDialog = true, _vm.workAssessmentDialog = false;
      }
    }
  }), _c('pre-work-analysis', {
    attrs: {
      "show": _vm.preWorkAnalysisDialog
    },
    on: {
      "confirmed": function confirmed($event) {
        var _vm3;
        return (_vm3 = _vm).preWorkAnalysisConfirmed.apply(_vm3, [_vm.callDetail.id].concat(Array.prototype.slice.call(arguments)));
      },
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        ;
        _vm.workAssessmentDialog = true, _vm.preWorkAnalysisDialog = false;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }